<template>
<div class="page-ohf">
  <div class="page-ohf_top"></div>
  <div class="page-ohf_center">
    <svg width="269" height="140" viewBox="0 0 269 140" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.6 94.24V86.96L57.54 22H68.74L17.22 86.96L11.76 85.28H90.58V94.24H5.6ZM60.9 120V94.24L61.18 85.28V62.6H70.98V120H60.9Z" fill="black"/>
      <path d="M181.6 94.24V86.96L233.54 22H244.74L193.22 86.96L187.76 85.28H266.58V94.24H181.6ZM236.9 120V94.24L237.18 85.28V62.6H246.98V120H236.9Z" fill="black"/>
      <path d="M123.405 42.6918C123.405 44.6267 121.837 46.1952 119.902 46.1952C117.967 46.1952 116.398 44.6267 116.398 42.6918C116.398 40.757 117.967 39.1885 119.902 39.1885C121.837 39.1885 123.405 40.757 123.405 42.6918Z" fill="black"/>
      <path d="M145.202 42.6918C145.202 44.6267 143.634 46.1952 141.699 46.1952C139.764 46.1952 138.195 44.6267 138.195 42.6918C138.195 40.757 139.764 39.1885 141.699 39.1885C143.634 39.1885 145.202 40.757 145.202 42.6918Z" fill="black"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M153.772 114.705V99.3291C153.772 86.7526 143.577 76.5573 131 76.5573C118.423 76.5573 108.228 86.7526 108.228 99.3291V114.705H153.772ZM131 70.3291C114.984 70.3291 102 83.3128 102 99.3291V120.933H160V99.3291C160 83.3128 147.016 70.3291 131 70.3291Z" fill="black"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M108.228 46C108.228 58.5765 118.423 68.7718 131 68.7718C143.577 68.7718 153.772 58.5765 153.772 46C153.772 33.4235 143.577 23.2282 131 23.2282C118.423 23.2282 108.228 33.4235 108.228 46ZM131 17C114.984 17 102 29.9837 102 46C102 62.0163 114.984 75 131 75C147.016 75 160 62.0163 160 46C160 29.9837 147.016 17 131 17Z" fill="black"/>
      <path d="M119.339 57.419C118.556 56.7136 118.487 55.4978 119.274 54.7969C120.645 53.5761 122.205 52.5783 123.896 51.8442C126.173 50.8562 128.635 50.369 131.117 50.4155C133.598 50.462 136.04 51.0411 138.278 52.1136C139.941 52.9105 141.463 53.9661 142.787 55.2374C143.548 55.9672 143.433 57.1796 142.624 57.8552V57.8552C141.815 58.5307 140.619 58.4105 139.836 57.7046C138.878 56.8406 137.798 56.1161 136.629 55.5556C134.884 54.7194 132.98 54.2679 131.045 54.2317C129.111 54.1954 127.191 54.5753 125.416 55.3456C124.226 55.8618 123.12 56.5454 122.13 57.373C121.322 58.049 120.122 58.1244 119.339 57.419V57.419Z" fill="black"/>
    </svg>
    <div class="text_1">{{params.text_1}}</div>
    <div class="text_2">{{params.text_2}}</div>
    <a class="btn_main" :href="params.btn_link">{{params.btn_text}}</a>
  </div>
  <div class="page-ohf_bottom"></div>
</div>
</template>

<script>

export default {
  name: '404',
  props: {
    params: {
      type: Object,
      default: {},
    }
  },
  setup: (props, ctx) => {

    return {

    }
  },
}
</script>

<style scoped>
.page-ohf{
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
}
.page-ohf .page-ohf_top{
  width: 100%;
  height: 431px;
  background: var(--c-secondary-200);
}
.page-ohf .page-ohf_center{
  position: absolute;
  height: 500px;
  width: 684px;
  left: 50%;
  z-index: 1;
  text-align: center;
  top:calc(50% + 50px);
  background: #FFFFFF;
  box-shadow: 0px 1px 1px rgb(0 0 0 / 5%), 0px 0px 40px rgb(0 0 0 / 10%);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  transform: translate(-50%, -50%);
}
.page-ohf .page-ohf_bottom{
  width: 100%;
  height: 331px;
  background: #fff;
}
.page-ohf .text_1{
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  margin-top: 25px;
}
.page-ohf .text_2{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
  margin-top: 15px;
  max-width: 487px;
}
.page-ohf .btn_main{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 15px;
  gap: 10px;
  background: #00A59E;
  border-radius: 6px;
  width: 350px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #FFFFFF;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin-top: 25px;
}
@media screen and (max-width: 767px) {
  .page-ohf .page-ohf_center{
    width: 100%;
    border-radius: 22px 22px 0px 0px;
  }
  .page-ohf .page-ohf_center svg{
    width: 200px;
    height: 104px;
  }
  .page-ohf .text_1{
    font-size: 22px;
    line-height: 28px;
  }
  .page-ohf .text_2{
    font-size: 16px;
    line-height: 26px;
  }
  .page-ohf .btn_main{
    max-width: 290px;
  }
}
@media screen and (max-width: 567px) {
  .page-ohf .text_2 {
    max-width: 300px;
  }
}
</style>